import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { NotFoundPageComponent } from '@app/core/not-found-page/not-found-page.component';

export const routes: Routes = [
  { path: '', loadChildren: 'app/landing/landing.module#LandingModule' },
  // { path: 'suggestions', pathMatch: 'full', redirectTo: 'stocks' },
  // { path: 'veteran', loadChildren: 'app/veterans/veterans.module#VeteransModule' },
  // { path: 'partner', loadChildren: 'app/partners/partners.module#PartnersModule' },
  // { path: 'auth', loadChildren: 'app/accounts/accounts.module#AccountsModule' },
  // { path: 'stocks', loadChildren: 'app/vouchers/vouchers.module#VouchersModule' },
  { path: 'about', loadChildren: 'app/faq/faq.module#FaqModule' },
  { path: 'magazine', loadChildren: 'app/magazine/magazine.module#MagazineModule' },
  // { path: 'social-support', loadChildren: 'app/social-support/social-support.module#SocialSupportModule' },
  { path: 'agreement', loadChildren: 'app/agreement/agreement.module#AgreementModule' },
  { path: 'feedbacks', loadChildren: 'app/feedbacks/feedbacks.module#FeedbacksModule' },
  // { path: 'search', loadChildren: 'app/search/search.module#SearchModule' },
  { path: '**', component: NotFoundPageComponent },
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ],
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts